module.exports = __webpack_public_path__ + "img/nl.bb9ab8e8.svg";